import React, { useContext } from 'react'
import { Header, Icon } from '@insight/toolkit-react'

import IAHeaderContext from '../../context/IAHeaderContext'
import IAHeaderMegaMenu from '../IAHeaderMegaMenu/IAHeaderMegaMenu'
import useFilteredItemMap from '../../hooks/useFilteredItemMap'
import { ENABLE_NIA } from '../../api/common/constants'

export default function DesktopNav({ isCES, setIsOpen }) {
  const {
    menuItems: { mainNav },
  } = useContext(IAHeaderContext)

  const handleClick = () => {
    setIsOpen(true)
  }

  const updatedNav = mainNav.concat({
    onClick: handleClick,
    title: <div className="c-header-main-nav__item-nia"><Icon icon="NIA" />Nia</div>,
    href: null,
    target: '_blank',
    type: 'link'
  })
  const NavigationMap = window?.flags && window?.flags[ENABLE_NIA] ? updatedNav: mainNav

  const filteredItemMap = useFilteredItemMap()

  const renderNavItem = (navItem, i) => {
    if (navItem?.type === 'link' && !navItem?.nodes) {
      // if the type of item is link and has no nodes attached to it , it will behave as link and not dropdown
      return <Header.Nav.Desktop.Item
              title={navItem?.title}
              href={navItem?.href}
              target={navItem?.targetBlank ? '_blank' : '_self'}
              onClick={navItem?.onClick}
              className='link-item'
            />
    }
    else {
      const id = `headerMega${i + 1}`
      return (
        <Header.Nav.Desktop.MegaMenu key={id} id={id} title={navItem.title}>
          <IAHeaderMegaMenu {...navItem} isCES={isCES} />
        </Header.Nav.Desktop.MegaMenu>
      )
    }
  }

  return (
    <Header.Nav.Desktop>
      {NavigationMap?.map((item, index) => {
        return filteredItemMap[item.id] ? null : renderNavItem(item, index)
      })}
    </Header.Nav.Desktop>
  )
}

DesktopNav.propTypes = {}
